export const Instagram = () => {
  return (
    <a href="https://www.instagram.com/cornellboxstudio/">
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_111_85)">
          <path
            d="M15.2756 2.66104C19.2234 2.66104 19.691 2.67836 21.2435 2.74762C22.6864 2.8111 23.4656 3.05351 23.9851 3.25552C24.6719 3.52102 25.1683 3.84423 25.6819 4.35791C26.2014 4.87736 26.5188 5.36795 26.7843 6.05478C26.9863 6.57423 27.2287 7.35917 27.2922 8.79632C27.3615 10.3547 27.3788 10.8222 27.3788 14.7642C27.3788 18.712 27.3615 19.1795 27.2922 20.7321C27.2287 22.175 26.9863 22.9542 26.7843 23.4737C26.5188 24.1605 26.1956 24.6568 25.6819 25.1705C25.1625 25.69 24.6719 26.0074 23.9851 26.2729C23.4656 26.4749 22.6807 26.7173 21.2435 26.7808C19.6852 26.8501 19.2177 26.8674 15.2756 26.8674C11.3278 26.8674 10.8603 26.8501 9.30773 26.7808C7.86482 26.7173 7.08564 26.4749 6.56619 26.2729C5.87936 26.0074 5.383 25.6842 4.86932 25.1705C4.34987 24.6511 4.03243 24.1605 3.76694 23.4737C3.56493 22.9542 3.32252 22.1693 3.25903 20.7321C3.18977 19.1738 3.17246 18.7063 3.17246 14.7642C3.17246 10.8164 3.18977 10.3489 3.25903 8.79632C3.32252 7.3534 3.56493 6.57423 3.76694 6.05478C4.03243 5.36795 4.35565 4.87159 4.86932 4.35791C5.38877 3.83846 5.87936 3.52102 6.56619 3.25552C7.08564 3.05351 7.87059 2.8111 9.30773 2.74762C10.8603 2.67836 11.3278 2.66104 15.2756 2.66104ZM15.2756 0.000305176C11.2643 0.000305176 10.7622 0.0176202 9.18653 0.0868801C7.61663 0.15614 6.53733 0.410093 5.60232 0.773708C4.62691 1.15464 3.80157 1.65677 2.98199 2.48212C2.15664 3.3017 1.65451 4.12704 1.27358 5.09668C0.909963 6.03746 0.65601 7.11099 0.58675 8.68088C0.51749 10.2623 0.500175 10.7645 0.500175 14.7758C0.500175 18.7871 0.51749 19.2892 0.58675 20.8649C0.65601 22.4348 0.909963 23.5141 1.27358 24.4491C1.65451 25.4245 2.15664 26.2498 2.98199 27.0694C3.80157 27.889 4.62691 28.3969 5.59655 28.772C6.53733 29.1357 7.61086 29.3896 9.18075 29.4589C10.7564 29.5281 11.2586 29.5454 15.2699 29.5454C19.2812 29.5454 19.7833 29.5281 21.359 29.4589C22.9289 29.3896 24.0082 29.1357 24.9432 28.772C25.9128 28.3969 26.7381 27.889 27.5577 27.0694C28.3773 26.2498 28.8852 25.4245 29.2604 24.4548C29.624 23.5141 29.8779 22.4405 29.9472 20.8706C30.0165 19.295 30.0338 18.7928 30.0338 14.7815C30.0338 10.7702 30.0165 10.2681 29.9472 8.69243C29.8779 7.12254 29.624 6.04323 29.2604 5.10823C28.8968 4.12704 28.3946 3.3017 27.5693 2.48212C26.7497 1.66254 25.9243 1.15464 24.9547 0.77948C24.0139 0.415865 22.9404 0.161912 21.3705 0.0926518C19.7891 0.0176202 19.2869 0.000305176 15.2756 0.000305176Z"
            fill="black"
          />
          <path
            d="M15.2769 7.18622C11.0866 7.18622 7.68713 10.5857 7.68713 14.776C7.68713 18.9662 11.0866 22.3657 15.2769 22.3657C19.4671 22.3657 22.8666 18.9662 22.8666 14.776C22.8666 10.5857 19.4671 7.18622 15.2769 7.18622ZM15.2769 19.6992C12.5584 19.6992 10.3536 17.4944 10.3536 14.776C10.3536 12.0575 12.5584 9.85273 15.2769 9.85273C17.9953 9.85273 20.2001 12.0575 20.2001 14.776C20.2001 17.4944 17.9953 19.6992 15.2769 19.6992Z"
            fill="black"
          />
          <path
            d="M24.9365 6.88598C24.9365 7.86716 24.14 8.65788 23.1646 8.65788C22.1834 8.65788 21.3927 7.86139 21.3927 6.88598C21.3927 5.90479 22.1892 5.11407 23.1646 5.11407C24.14 5.11407 24.9365 5.91057 24.9365 6.88598Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_111_85">
            <rect
              width="29.5509"
              height="29.5509"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </a>
  );
};

export const Pinterest = () => {
  return (
    <a href="https://pin.it/2XUnrccKe">
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.3773 0C7.21613 0 0.601807 6.61432 0.601807 14.7755C0.601807 21.0377 4.49768 26.3823 9.9923 28.5351C9.86532 27.3634 9.74412 25.5742 10.0442 24.2987C10.3155 23.1444 11.7757 16.9571 11.7757 16.9571C11.7757 16.9571 11.3313 16.0741 11.3313 14.7639C11.3313 12.7092 12.5203 11.1739 14.0036 11.1739C15.2618 11.1739 15.8736 12.1205 15.8736 13.2575C15.8736 14.5273 15.0656 16.4204 14.65 18.175C14.3037 19.6467 15.3888 20.8472 16.8375 20.8472C19.4636 20.8472 21.4837 18.0768 21.4837 14.0829C21.4837 10.5448 18.9441 8.06878 15.3138 8.06878C11.112 8.06878 8.64173 11.2201 8.64173 14.4811C8.64173 15.7509 9.13232 17.113 9.74412 17.8517C9.86532 17.996 9.88264 18.1288 9.84801 18.2731C9.73835 18.7406 9.48439 19.7449 9.43822 19.9469C9.37473 20.2181 9.22467 20.2758 8.94186 20.1431C7.09493 19.2831 5.94059 16.5878 5.94059 14.4176C5.94059 9.75411 9.32856 5.47731 15.7005 5.47731C20.8257 5.47731 24.8082 9.13077 24.8082 14.0136C24.8082 19.1042 21.5991 23.2021 17.1434 23.2021C15.6485 23.2021 14.2402 22.4229 13.7554 21.5052C13.7554 21.5052 13.0167 24.3276 12.8377 25.0202C12.503 26.3015 11.6026 27.9118 11.0023 28.8929C12.3875 29.32 13.8535 29.5509 15.3773 29.5509C23.5384 29.5509 30.1527 22.9366 30.1527 14.7755C30.1527 6.61432 23.5384 0 15.3773 0Z"
          fill="black"
        />
      </svg>
    </a>
  );
};

export const BlueSky = () => {
  return (
    <a href="https://bsky.app/profile/fazakerleysam.bsky.social">
      <svg
        width="35"
        height="31"
        viewBox="0 0 35 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.3998 2.02324C11.3136 4.96148 15.5233 10.919 17.069 14.1162C18.6147 10.9192 22.8242 4.96142 26.7381 2.02324C29.5621 -0.0968747 34.1377 -1.7373 34.1377 3.48262C34.1377 4.52511 33.54 12.2401 33.1895 13.4926C31.9709 17.8471 27.5306 18.9577 23.5809 18.2855C30.4849 19.4606 32.2413 23.3527 28.4483 27.2449C21.2447 34.6368 18.0946 25.3902 17.2871 23.0209C17.1391 22.5865 17.0699 22.3833 17.0689 22.5561C17.0678 22.3833 16.9986 22.5865 16.8506 23.0209C16.0435 25.3902 12.8934 34.637 5.68943 27.2449C1.8964 23.3527 3.65266 19.4603 10.5568 18.2855C6.60696 18.9577 2.16661 17.8471 0.948258 13.4926C0.597689 12.24 0 4.52499 0 3.48262C0 -1.7373 4.57572 -0.0968747 7.3996 2.02324H7.3998Z"
          fill="black"
        />
      </svg>
    </a>
  );
};

export const LinkedIn = () => {
  return (
    <a href="https://www.linkedin.com/in/sam-fazakerley-111a6b13/">
      <svg
        width="29"
        height="30"
        viewBox="0 0 29 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.49764 6.58348C5.2855 6.58348 6.73485 5.10972 6.73485 3.29174C6.73485 1.47376 5.2855 0 3.49764 0C1.70978 0 0.260437 1.47376 0.260437 3.29174C0.260437 5.10972 1.70978 6.58348 3.49764 6.58348ZM6.27311 8.97746H0.723614V29.5508H6.27311V8.97746ZM22.9195 29.5508H28.469V16.9263C28.469 7.08845 18.11 7.44381 15.5202 12.2879V8.97746H9.9707V29.5508H15.5202V19.0771C15.5202 13.2605 22.9195 12.7742 22.9195 19.0771V29.5508Z"
          fill="black"
        />
      </svg>
    </a>
  );
};

export const Logo = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.1759 44.3432H25.3507L22.9676 49.5441H14.2153L27.6038 22.7751H36.0528L49.4846 49.5441H40.5589L38.1759 44.3432ZM35.6628 38.76L31.7633 30.194L27.8637 38.76H35.6628Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 24.9004H13.4688C16.5884 24.9004 19.3554 25.405 21.7698 26.4142C24.1841 27.4234 26.0559 28.8551 27.3852 30.7093C28.7144 32.5634 29.379 34.7344 29.379 37.2223C29.379 39.7101 28.7144 41.8811 27.3852 43.7352C26.0559 45.5894 24.1841 47.0211 21.7698 48.0303C19.3554 49.0395 16.5884 49.5441 13.4688 49.5441H0V24.9004ZM21.2408 37.2223C21.2408 39.3346 20.4948 40.9892 19.0028 42.1862C17.2332 43.6322 15.3589 43.9817 13.1433 43.9817H8.05685V30.4628H13.1433C15.5847 30.4628 17.5379 31.0613 19.0028 32.2583C20.4948 33.4553 21.2408 35.1099 21.2408 37.2223Z"
        fill="black"
      />
      <path
        d="M36.0811 6.27568V10.6962H46.7244V16.6144H36.0756V28.8575L27.6355 28.8576V0L49.5443 0.000635337V6.27633L36.0811 6.27568Z"
        fill="black"
      />
      <path
        d="M12.7819 26.2922C10.3266 26.2922 7.94354 26.0394 5.63269 25.5337C3.32185 25.0281 1.44429 24.354 1.57145e-05 23.5113L0 17.284C1.35762 18.0304 5.74824 19.5868 7.53914 20.0442C9.33004 20.5017 11.0921 20.7304 12.8252 20.7304C16.1181 20.7304 17.7646 20.0442 17.7646 18.6718C17.7646 17.9495 17.288 17.4198 16.3348 17.0828C15.4104 16.7216 13.9084 16.3484 11.8286 15.9632C9.54668 15.5539 7.64024 15.1205 6.1093 14.663C4.57837 14.1815 3.26408 13.4231 2.16643 12.3878C1.06878 11.3525 0.519955 9.95602 0.519955 8.19841C0.519955 6.65749 1.02545 5.27307 2.03645 4.04515C3.04744 2.79316 4.54949 1.80601 6.54259 1.0837C8.56457 0.361397 11.0343 0.000244141 13.9517 0.000244141C15.9448 0.000244141 17.909 0.192859 19.8444 0.57809C21.7797 0.939242 23.484 1.48097 24.9571 2.20328L24.6971 7.83726C21.8086 6.53711 16.6236 5.562 13.9084 5.562C12.2042 5.562 10.9621 5.77869 10.1822 6.21207C9.40225 6.62138 9.0123 7.16311 9.0123 7.83726C9.0123 8.51141 9.47447 9.01702 10.3988 9.3541C11.3231 9.69118 12.8107 10.0403 14.8616 10.4014C17.1725 10.8107 19.0789 11.2562 20.581 11.7377C22.1119 12.1952 23.4262 12.9415 24.5238 13.9769C25.6504 14.9881 26.2136 16.3725 26.2136 18.1301C26.2136 19.647 25.7081 21.0193 24.6971 22.2473C23.6862 23.4752 22.1697 24.4623 20.1477 25.2087C18.1257 25.931 15.6704 26.2922 12.7819 26.2922Z"
        fill="black"
      />
    </svg>
  );
};
